export const QUICKBOOKS_FINANCE_DASHBOARD_EMAILS = new Set([
    'laura.velasquez@amevel.com',
    'vane.ortiz@coffeevending.com.pa'
]);

export const QUICKBOOKS_MANAGEMENT_DASHBOARD_EMAILS = new Set([
    'juanameijeirasv@gmail.com',
    'mariela.velasquez@amevel.com',
    'lisbeth.velasquez@coffeevending.com.pa',
    'laura.velasquez@amevel.com',
    'juan.ameijeiras@amevel.com',
    'valentina.haliwa@amevel.com'
]);

export const normalizeQuickBooksAccessEmail = (email) => String(email || '').trim().toLowerCase();

export const hasQuickBooksFinanceDashboardAccess = (email) =>
    QUICKBOOKS_FINANCE_DASHBOARD_EMAILS.has(normalizeQuickBooksAccessEmail(email));

export const hasQuickBooksManagementDashboardAccess = (email) =>
    QUICKBOOKS_MANAGEMENT_DASHBOARD_EMAILS.has(normalizeQuickBooksAccessEmail(email));

// Read-only access to every QuickBooks view; does not confer administrative actions.
export const hasQuickBooksFullReadAccess = (email) => normalizeQuickBooksAccessEmail(email) === 'juan.ameijeiras@amevel.com';
export const getQuickBooksViewAccess = (role, email) => {
    const admin = ['admin', 'superAdmin'].includes(role);
    const fullRead = hasQuickBooksFullReadAccess(email);
    const finance = role === 'finance' || hasQuickBooksFinanceDashboardAccess(email);
    const management = admin || hasQuickBooksManagementDashboardAccess(email);
    return { fullRead, readOnly: fullRead && !admin && !finance,
        managementOnly: !admin && management && !finance && !fullRead,
        financeOnly: !admin && finance && !fullRead,
        finance: admin || finance || fullRead, management };
};
